// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_lc-0";
export var discountCodeInput = "_lc-1";